module.exports = __webpack_public_path__ + "img/default-question-zip.a50b5ae0.svg";